import { useState, useCallback } from 'react';
import { useEffectiveUser } from './useEffectiveUser';

interface UseRequireAuthReturn {
  isGuest: boolean;
  showAuthModal: boolean;
  authModalMessage: string;
  requireAuth: (action: () => void, customMessage?: string) => void;
  closeAuthModal: () => void;
}

export function useRequireAuth(): UseRequireAuthReturn {
  const { user, isLoggedOut } = useEffectiveUser();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalMessage, setAuthModalMessage] = useState('');

  const isGuest = isLoggedOut || !user || !user.id;

  const requireAuth = useCallback((action: () => void, customMessage?: string) => {
    if (isGuest) {
      setAuthModalMessage(customMessage || "To save your reactions and track your civic memory, you'll need a civicbeat profile.");
      setShowAuthModal(true);
    } else {
      action();
    }
  }, [isGuest]);

  const closeAuthModal = useCallback(() => {
    setShowAuthModal(false);
    setAuthModalMessage('');
  }, []);

  return {
    isGuest,
    showAuthModal,
    authModalMessage,
    requireAuth,
    closeAuthModal,
  };
}

export function guardedAction(isGuest: boolean, onAllowed: () => void, onBlocked?: () => void): void {
  if (isGuest) {
    onBlocked?.();
  } else {
    onAllowed();
  }
}
